import React from "react";
import I18n from "i18n.js.erb";
import LineChart from "./LineChart";
import { isDefined, CURRENCY_EURO } from "../../utils/utils";

const DOUGHNUT_OPTIONS = {
  plugins: {
    tooltip: { enabled: false },
    legend: { display: false },
    datalabels: { display: false }
  },
  cutout: '75%'
};

const LoopStatsChart = ({ stats, index, showDetails, onToggleDetails }) => {
  const presentAnalytics = stats?.analytics?.length > 0;

  return (
    <div className="d-flex flex-directions-column justify-content-between w-100 br-8px py-3 bg-aig-gradient-light">
      <div className="d-block">
        <div className="d-block d-sm-flex justify-content-between align-items-end pt-2">
          {stats.chart_title && (
            <div className="d-flex text-intense-blue mx-3">
              <div>
                {stats.chart_supertitle && (
                  <h4 className="mb-n1 text-weight-700">{stats.chart_supertitle.toUpperCase()}</h4>
                )}
                <h5 className="mb-0 font-weight--normal">{stats.chart_title.toUpperCase()}</h5>
              </div>
            </div>
          )}
          <div className="text-aig-gradient mx-3">
            <h2 className="my-0">
              <b>
                {stats.items_count}
                {stats.items_count_decimals && (
                  <span className="font-size-18px text-weight-500">{stats.items_count_decimals}</span>
                )}
              </b>
              {stats.items_type && (
                <span className="font-size-18px text-weight-500 text-capitalize">{' '}{stats.items_type}</span>
              )}
            </h2>
          </div>
        </div>

        {stats.datasets && (
          <div className="row d-flex align-items-center p-3">
            <div className="col-12 col-md-4">
              <LineChart
                type={'doughnut'}
                datasets={stats.datasets}
                labels={stats.legend_labels}
                options={DOUGHNUT_OPTIONS}
                maxHeight={'100px'}
                id={`loop_stats_chart_${index}`}
              />
            </div>

            <div className="col-12 col-md-8 d-flex px-0 flex-wrap justify-content-center d-md-block loop-stats-legend">
              {stats.legend_labels.map((label, idx) => (
                <div
                  className="row d-flex align-items-center m-auto px-2 px-md-0 py-1"
                  style={{ color: stats.legend_colors[idx] }}
                  key={label}
                >
                  <div className={`col-${isDefined(stats.legend_values) ? '6' : '12'} d-flex justify-content-center justify-content-md-start align-items-center px-0`}>
                    <div className="h-15px w-15px mr-2">
                      <div className="w-100 h-100perc br-50px" style={{ backgroundColor: stats.legend_colors[idx] }} />
                    </div>
                    <h5 className="my-0 font-weight--normal">{label.toUpperCase()}{stats.show_currency && CURRENCY_EURO}</h5>
                  </div>

                  {isDefined(stats.legend_values) && (
                    <div className="col-6 d-flex justify-content-center justify-content-md-end pb-1">
                      <h3 className="my-0 d-flex align-items-baseline">
                        <b>{stats.legend_values[idx][0]}</b>
                        <div className="font-size-16px-imp my-0 ml-1 text--white-space-no-wrap text-capitalize">{stats.legend_values[idx][1]}</div>
                      </h3>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {presentAnalytics && (
        <div className="d-block">
          <div className="w-100 px-3 mb-1">
            <div className="d-flex m-auto text-intense-blue">
              <h5
                className="d-flex my-0 cursor-pointer font-weight--normal"
                onClick={onToggleDetails}
              >
                {I18n.t('js.loopDashboard.stats.details').toUpperCase()}
                <img
                  src={window.location.origin + `/images/icons/blue/arrow-${showDetails ? 'up' : 'down'}.svg`}
                  alt="" width="10" height="10" className="ml-2"
                />
              </h5>
            </div>
          </div>

          {showDetails && (
            <div className="row m-auto statistics-row text-intense-blue loop-stats-details">
              {stats.analytics.map((analytic, idx) => (
                <div className="col-6 col-sm-4 d-block text-center text-sm-start pl-3 pr-1 py-2" key={idx}>
                  <h5 className="mb-0 font-weight--normal">{analytic.label.toUpperCase()}{stats.show_currency && CURRENCY_EURO}</h5>
                  <h3 className="my-0 d-flex justify-content-center justify-content-sm-start align-items-baseline">
                    <b>{analytic.values[0]}</b>
                  </h3>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(LoopStatsChart);
